import request from '@/utils/request'

/**
 * 获取需求发布列表信息
 * @param {} data 
 * @returns 
 */
export function getXQFBList(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Query/dzpm/GetXQFBList',
        method: 'post',
        params: data
    })
}


/**
 * 
 * @param {} data 
 * @returns 
 */
 export function GetTheData(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Query/dzpm/GetTheDataForTradeLeads',
        method: 'post',
        params: data
    })
}

export function editlist(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/TradeLeads/editlist',
        method: 'post',
        data
    })
}

export function dellist(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/TradeLeads/del',
        method: 'post',
        params: data
    })
}

export function addLike(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/TradeLeads/Like',
        method: 'post',
        params: data
    })
}

export function cancelLike(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/TradeLeads/CancelLike',
        method: 'post',
        params: data
    })
}

export function getLikeStatus(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/TradeLeads/GetLikeStatus',
        method: 'post',
        params: data
    })
}

export function addComment(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/TradeLeads/AddComment',
        method: 'post',
        data
    })
}

export function getCommentList(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/TradeLeads/GetCommentList',
        method: 'post',
        params: data
    })
}

export function deleteComment(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/TradeLeads/DeleteComment',
        method: 'post',
        params: data
    })
}

export function deleteAllComments(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/TradeLeads/DeleteAllComments',
        method: 'post',
        params: data
    })
}





// WEBPACK FOOTER //
// ./src/api/TradeLeads_api.js